<template>
    <div class="page-error">
        <div class="container">
            <div class="row page-error--content">
                <div class="col page-error--img  d-flex justify-content-center">
                    <div id="ginny-404" class="ginny-404 lottie-animation__img-404" />
                </div>
                <div
                    class="col page-error--text fast animated slideInUp">
                    <h1>Tenemos 404 tips para manejar tus tarjetas</h1>
                    <p>Pero no hemos encontrado la página que estás buscando</p>
                    <a href="/" class="">Volver al inicio</a>
                </div>
		</div>
    </div>
    </div>
</template>

<script>
import lottie from 'lottie-web';

export default {
    name: 'Page404',
    mounted() {
        lottie.loadAnimation({
            container: document.getElementById('ginny-404'),  // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: "/404-ginny.json",
            assetsPath: "../assets/animations"
        });
    }
}
</script>

<style lang="scss">
.lottie-animation__img-404 {
    svg {
        width: 150%!important;
    }
}

[data-scroll-class] {
    opacity: 1;
}
// Page Error
.page-error {
    background: url('../assets/images/bg-1.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 120px;
    background-attachment: fixed;
}
.page-error--content {
    min-height: 725px;
    display: flex;
    align-items: center;
    height: 100%;

    h1 {
        font-family: $primary-font;
        color: $orange-dark-color;
        font-size: $extra-large-font-size;
    }

    p {
        font-size: $medium-font-size;
    }
}
.lottie-animation__img-404 {
    svg {
        width: 150%!important;
    }
}
// Medium devices (desktop, 991px)
@media screen and (max-width: 991px) {
    .page-error--content {
        flex-direction: column;
        text-align: center;

        h1 {
            font-size: $large-font-size;
            max-width: 400px;
            width: 100%;
            margin: 0 auto;
        }

        p {
            font-size: $small-font-size;
            margin-top: 15px;
        }

        .page-error--img {
            padding-top: 80px;
            padding-bottom: 40px;
        }
    }
    .lottie-animation__img-404 {
        svg {
            width: 100%!important;
        }
    }
}
// Medium devices (tablet, 768px)
@media screen and (max-width: 768px) {
    .page-error--content {
        .page-error--img {
            position:relative!important;

            .ginny-404 {
                position:absolute;
                bottom: 0;
                left: -40%;
                right: 45%;
                top: 0;
            }
            img {
                height: 300px;
            }
        }

        .lottie-animation__img-404 {
            svg {
                width: 200%!important;
                }
            }
    }
}
</style>